import { Routes } from '@angular/router';

export const VISITOR_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('../modules/visitor/visitor.module').then(m => m.VisitorModule)
  },
  {
    path: 'resetpwd',
    loadChildren: () => import('../modules/visitor/resetpwd/resetpwd.module').then(m => m.ResetPwdModule)
  },
  {
    path: 'confirmRegistration',
    loadChildren: () => import('../modules/visitor/confirmRegistration/confirm-registration.module').then(m => m.confirmRegistration)
  },

]
